import { render, staticRenderFns } from "./StudioTabNav.vue?vue&type=template&id=5b077782&scoped=true&"
import script from "./StudioTabNav.vue?vue&type=script&lang=js&"
export * from "./StudioTabNav.vue?vue&type=script&lang=js&"
import style0 from "./StudioTabNav.vue?vue&type=style&index=0&id=5b077782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b077782",
  null
  
)

component.options.__file = "StudioTabNav.vue"
export default component.exports